import { render } from "./App.vue?vue&type=template&id=117181b3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=117181b3&lang=less"

import exportComponent from "/var/jenkins_home/workspace/prod_web_mall_haier_mall/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__